export enum CorporateBundle {
    STARTER = "STARTER",
    ESSENTIALS = "ESSENTIALS",
    POWER = "POWER",
    ENTERPRISE = "ENTERPRISE",
}

export const CORPORATE_BUNDLES = Object.keys(CorporateBundle);

export enum SmbBundle {
    SELECT_50 = "SELECT_50",
    SELECT_100 = "SELECT_100",
    SELECT_PLUS_250 = "SELECT_PLUS_250",
    SELECT_PLUS_500 = "SELECT_PLUS_500",
}

export const SMB_BUNDLE = Object.keys(SmbBundle);

export enum ProcessorBundle {
    CORE = "CORE",
    PRO = "PRO",
    PRO_SCALE = "PRO_SCALE",
}

export enum MobileRetailBundle {
    MOBILE_RETAIL_LITE = "MOBILE_RETAIL_LITE",
    MOBILE_RETAIL_PLUS = "MOBILE_RETAIL_PLUS",
    MOBILE_RETAIL_PRO = "MOBILE_RETAIL_PRO",
}
export enum MobileProcessorBundle {
    MOBILE_PROCESSOR_CORE = "MOBILE_PROCESSOR_CORE",
    MOBILE_PROCESSOR_PRO = "MOBILE_PROCESSOR_PRO",
    MOBILE_PROCESSOR_PRO_SCALE = "MOBILE_PROCESSOR_PRO_SCALE",
}

export const PROCESSOR_BUNDLES = Object.keys(ProcessorBundle);

export const MOBILE_RETAIL_BUNDLES = Object.keys(MobileRetailBundle);
export const MOBILE_PROCESSOR_BUNDLES = Object.keys(MobileProcessorBundle);

export enum ChannelBundle {
    PRO_SCALE = "PRO_SCALE",
}

export const CHANNEL_BUNDLES = Object.keys(ChannelBundle);

export const MANAGEMENT_CONSOLE_LICENSE = "51";
export const AUTOPILOT_RECHECK_LICENSE = "83";
export const PRE_POPULATED_ADD_ON_LICENSES = ["24", "32"];

export const BUNDLE_ONLY_LICENSES = [AUTOPILOT_RECHECK_LICENSE];
export enum BundlesTenantTypes {
    CORPORATE = "CORPORATE",
    PROCESSOR = "PROCESSOR",
    SMB = "SMB",
    CHANNEL = "CHANNEL",
    MOBILE_RETAIL = "MOBILE_RETAIL",
    MOBILE_PROCESSOR = "MOBILE_PROCESSOR",
}
